/* tia-cp-sizefit.js: the Size Chart and Wall Fit module's script, lifted out of
   snippets/tia-cp-sizefit.liquid on 2026-09-17 (seo-content/pdp-speed-2026-09-17) to be cached
   across product pages. The snippet renders the markup, the data island and the CSS. */
(function(){
  /* Widths and heights in inches. Height is what decides how much wall the drawing has to
     show, which is why a queen bed and a console produce different scenes from one size. */
  var FURNITURE=[
    {id:'sofa',      name:'sofa',       label:'Sofa · 84"',      w:84,h:34},
    {id:'bed',       name:'queen bed',  label:'Queen Bed · 62"', w:62,h:48},
    {id:'console',   name:'console',    label:'Console · 48"',   w:48,h:30},
    {id:'fireplace', name:'fireplace',  label:'Fireplace · 60"', w:60,h:46}
  ];
  var GAP_ABOVE=7;   /* inches of clear wall between the furniture top and the art bottom */
  var BOX=9/8;       /* MUST equal .tsf__stage's aspect-ratio: the wall width is solved against it */
  var TIER=[['var(--tsf-pA)','var(--tsf-pAs)'],['var(--tsf-pB)','var(--tsf-pBs)'],['var(--tsf-pC)','var(--tsf-pCs)']];

  /* What the selected finish puts between the edge of the piece and the picture, in inches.
     A Framed Print is a frame plus a mat board; a Framed Canvas is a frame plus the floater's
     open gap. Both are single panel only, which is why this can assume one rectangle.

     🔴 DRAWN INSIDE THE SIZE THE CHART STATES, NEVER ADDED OUTSIDE IT. The overall figure is
     the one the store publishes and the one this module's rules measure, and adding invented
     inches to it in a drawing that promises "true to scale" would be a false claim in picture
     form. The proportions themselves are indicative, which the note says out loud.
     ⚠ The finish studio further down the page adds its frame OUTSIDE the stated size, because
     it is a construction diagram and says so. Whether the published Framed Print size is the
     paper or the finished frame is NOT known in this workspace — see the owner note in
     CHANGELOG 2026-08-19d. */
  function bands(mat){
    var m=String(mat||'').toLowerCase();
    if(m.indexOf('framed print')>-1) return {frame:1.05, mid:1.60, fill:'var(--tsf-card)', kind:'print'};
    if(m.indexOf('framed')>-1)       return {frame:0.55, mid:0.25, fill:'var(--tsf-recess)', kind:'floater'};
    return null;
  }
  var f=function(n){return Math.round(n*100)/100;};
  var esc=function(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;');};

  function boot(root){
    if(root.dataset.tsfInit==='1') return;
    var G=window.TiaPdpGeo;
    if(!G) return;                       /* asset not parsed yet; initAll runs again on load */
    root.dataset.tsfInit='1';

    var slot=root.querySelector('[data-tsf-slot]'), data;
    try{ data=JSON.parse(root.querySelector('[data-tsf-product]').textContent); }
    catch(e){ return; }

    var built=G.buildLive(data.names,data.variants);
    if(!built.live.length){
      /* Nothing resolved. Reveal the original metafield tables rather than showing less than
         the page showed before, and take this module out of the flow entirely. */
      var fb=document.querySelector('[data-tsf-fallback],[data-tsc-fallback]');
      if(fb) fb.removeAttribute('hidden');
      root.style.display='none';
      return;
    }

    var state={furn:'sofa', entry:built.live[0], sizeIdx:0, preview:null, showRef:true, unit:'in'};
    try{ if(localStorage.getItem('tiaUnit')==='cm') state.unit='cm'; }catch(e){}

    /* ---- units. Every dimension the module prints goes through these two ---- */
    function one(n){
      if(state.unit==='cm') return Math.round(n*2.54)+' cm';
      return (n%1===0?n:f(n))+'″';
    }
    function pair(w,h){
      if(state.unit==='cm') return Math.round(w*2.54)+' × '+Math.round(h*2.54)+' cm';
      return (w%1===0?w:f(w))+'″ × '+(h%1===0?h:f(h))+'″';
    }

    /* ---- the furniture, drawn in ITS OWN inch space and translated into the scene ---- */
    function furnitureShapes(fu){
      var s='fill="var(--tsf-furn)" stroke="var(--tsf-furn-line)" stroke-width="0.6" vector-effect="non-scaling-stroke"';
      if(fu.id==='sofa') return ''+
        '<rect x="2" y="0" width="'+(fu.w-4)+'" height="18" rx="3" '+s+'/>'+
        '<rect x="0" y="7" width="8" height="20" rx="2.5" '+s+'/>'+
        '<rect x="'+(fu.w-8)+'" y="7" width="8" height="20" rx="2.5" '+s+'/>'+
        '<rect x="6" y="18" width="'+(fu.w-12)+'" height="10" rx="2" '+s+'/>'+
        '<rect x="9" y="30" width="3" height="4" '+s+'/>'+
        '<rect x="'+(fu.w-12)+'" y="30" width="3" height="4" '+s+'/>';
      /* A queen bed seen from the foot: headboard behind, two pillows against it, the
         mattress slab, the divan base, feet. The first draft drew one tall rounded block
         and read as an armchair, which makes the 62in reference useless. */
      if(fu.id==='bed') return ''+
        '<rect x="3" y="0" width="'+(fu.w-6)+'" height="23" rx="3" '+s+'/>'+
        '<rect x="8" y="15" width="'+(fu.w/2-11)+'" height="9" rx="4" '+s+'/>'+
        '<rect x="'+(fu.w/2+3)+'" y="15" width="'+(fu.w/2-11)+'" height="9" rx="4" '+s+'/>'+
        '<rect x="0" y="24" width="'+fu.w+'" height="8" rx="2" '+s+'/>'+
        '<rect x="2" y="32" width="'+(fu.w-4)+'" height="10" rx="1" '+s+'/>'+
        '<rect x="1" y="42" width="4" height="6" '+s+'/>'+
        '<rect x="'+(fu.w-5)+'" y="42" width="4" height="6" '+s+'/>';
      if(fu.id==='console') return ''+
        '<rect x="0" y="0" width="'+fu.w+'" height="5" rx="1" '+s+'/>'+
        '<rect x="2" y="5" width="'+(fu.w-4)+'" height="17" '+s+'/>'+
        '<rect x="3" y="22" width="3" height="8" '+s+'/>'+
        '<rect x="'+(fu.w-6)+'" y="22" width="3" height="8" '+s+'/>';
      return ''+
        '<rect x="0" y="0" width="'+fu.w+'" height="5" '+s+'/>'+
        '<rect x="5" y="5" width="'+(fu.w-10)+'" height="'+(fu.h-5)+'" '+s+'/>'+
        '<rect x="11" y="13" width="'+(fu.w-22)+'" height="'+(fu.h-15)+'" fill="var(--tsf-fire)" stroke="var(--tsf-furn-line)" stroke-width="0.6" vector-effect="non-scaling-stroke"/>';
    }

    /* ---- the scene. Authored in inches; the browser does the fitting ---- */
    function scene(l,s){
      var P=G.panels(l,s), aW=G.DW(s), aH=G.DH(s);
      /* The finish comes from the geometry entry, which is already finish specific — the table
         carries separate rows for Canvas Print, Framed Canvas and Framed Print. */
      var fin=bands(l.mat), inset=0;
      if(fin){
        inset=fin.frame+fin.mid;
        /* Never let the finish eat more than a fifth of the short side, whatever the size. */
        var lim=Math.min(aW,aH)*0.20;
        if(inset>lim){ var q=lim/inset; fin={frame:fin.frame*q, mid:fin.mid*q, fill:fin.fill, kind:fin.kind}; inset=lim; }
      }
      var fu=FURNITURE.filter(function(x){return x.id===state.furn;})[0];
      var ref=state.showRef;

      /* 🔵 THE WALL WIDTH IS CHOSEN TO FILL THE BOX, NOT PICKED. How much wall to draw is a
         drawing convention rather than a fact about the product, so it is the free variable:
         the scene's HEIGHT is fixed by the artwork plus the furniture, and the wall is then
         set to whatever makes the scene's ratio match the stage's, clamped so there is always
         air around both and a small piece is never marooned in a hall. A hardcoded wall width
         left a 16in piece beside an 84in sofa letterboxed at 1.55 against a 1.125 box, which
         is a third of the stage spent on nothing. */
      var bodyH = aH + (ref ? GAP_ABOVE+fu.h : 0);
      var minW  = ref ? Math.max(aW*1.14, fu.w*1.14) : aW*1.10;
      var maxW  = ref ? Math.max(minW, aW*2.6, fu.w*1.9) : aW*1.5;
      var k     = Math.max(minW, bodyH);           /* the scene's own scale unit */
      var fs    = k*0.036, gapR = k*0.05, tick = k*0.013, hair = k*0.0035;
      var head  = gapR + fs*1.9;                   /* room above the art for the width rule */
      var side  = gapR + fs*1.9;                   /* room left of the art for the height rule */
      var floorH= ref ? k*0.022 : 0;
      var wallW = Math.min(maxW, Math.max(minW, (head+bodyH+floorH)*BOX - fs*0.6));

      var aTop=head, aLeft=(wallW-aW)/2;
      var fuTop=head+aH+GAP_ABOVE, base=head+bodyH;
      var o='', defs='', uid='tsf'+data.id+'-';

      if(ref){
        o+='<rect x="'+f(Math.min(0,aLeft-side))+'" y="'+f(base)+'" width="'+f(Math.max(wallW,aLeft+aW)-Math.min(0,aLeft-side)+side)+
           '" height="'+f(floorH)+'" fill="var(--tsf-line)"/>'+
           '<g transform="translate('+f((wallW-fu.w)/2)+','+f(fuTop)+')">'+furnitureShapes(fu)+'</g>';
      }

      P.forEach(function(p,i){
        var x=f(aLeft+p.x), y=f(aTop+p.y), w=f(p.w), h=f(p.h);
        /* Frame band, then mat board or floater gap, then the picture inside them. Drawn
           before the image so the image sits on top of its own opening. */
        if(fin){
          o+='<rect x="'+x+'" y="'+y+'" width="'+w+'" height="'+h+'" fill="var(--tsf-frame)"/>'+
             '<rect x="'+f(aLeft+p.x+fin.frame)+'" y="'+f(aTop+p.y+fin.frame)+'" width="'+f(p.w-2*fin.frame)+
             '" height="'+f(p.h-2*fin.frame)+'" fill="'+fin.fill+'"/>';
        }
        var ix=f(aLeft+p.x+inset), iy=f(aTop+p.y+inset), iw=f(p.w-2*inset), ih=f(p.h-2*inset);
        if(data.flat){
          /* Every copy is placed on the WHOLE picture rectangle and clipped to this panel,
             so the five panels are five cuts of one picture rather than five copies. With a
             finish that rectangle is the frame's opening, not the outside of the piece. */
          defs+='<clipPath id="'+uid+i+'"><rect x="'+ix+'" y="'+iy+'" width="'+iw+'" height="'+ih+'"/></clipPath>';
          o+='<image href="'+esc(data.flat)+'" x="'+f(aLeft+inset)+'" y="'+f(aTop+inset)+'" width="'+f(aW-2*inset)+
             '" height="'+f(aH-2*inset)+'" preserveAspectRatio="xMidYMid slice" clip-path="url(#'+uid+i+')"/>'+
             '<rect x="'+ix+'" y="'+iy+'" width="'+iw+'" height="'+ih+'" fill="none" stroke="'+TIER[p.tier][1]+
             '" stroke-width="'+f(hair)+'"/>';
        }else{
          o+='<rect x="'+ix+'" y="'+iy+'" width="'+iw+'" height="'+ih+'" fill="'+TIER[p.tier][0]+
             '" stroke="'+TIER[p.tier][1]+'" stroke-width="'+f(hair)+'" rx="'+f(k*0.002)+'"/>';
        }
      });

      /* Width rule above the art, height rule at its left. Both are the size chart's, kept
         because "how big is it" and "will it fit" are the same question asked twice. */
      var wy=aTop-gapR;
      o+='<g stroke="var(--tsf-a)" stroke-width="'+f(hair)+'" fill="none">'+
         '<path d="M'+f(aLeft)+' '+f(wy-tick/2)+'V'+f(wy+tick/2)+'M'+f(aLeft+aW)+' '+f(wy-tick/2)+'V'+f(wy+tick/2)+'"/>'+
         '<path d="M'+f(aLeft)+' '+f(wy)+'H'+f(aLeft+aW)+'"/></g>'+
         '<text x="'+f(aLeft+aW/2)+'" y="'+f(wy-tick*0.7)+'" font-size="'+f(fs)+'" text-anchor="middle" fill="var(--tsf-a)">'+one(aW)+'</text>';
      var hx=aLeft-gapR;
      o+='<g stroke="var(--tsf-a)" stroke-width="'+f(hair)+'" fill="none">'+
         '<path d="M'+f(hx-tick/2)+' '+f(aTop)+'H'+f(hx+tick/2)+'M'+f(hx-tick/2)+' '+f(aTop+aH)+'H'+f(hx+tick/2)+'"/>'+
         '<path d="M'+f(hx)+' '+f(aTop)+'V'+f(aTop+aH)+'"/></g>'+
         '<text x="'+f(hx-tick*0.7)+'" y="'+f(aTop+aH/2)+'" font-size="'+f(fs)+'" text-anchor="middle" fill="var(--tsf-a)" transform="rotate(-90 '+
         f(hx-tick*0.7)+' '+f(aTop+aH/2)+')">'+one(aH)+'</text>';

      var minX=Math.min(0,aLeft-side), maxX=Math.max(wallW,aLeft+aW)+fs*0.6;
      var vb=[f(minX),0,f(maxX-minX),f(base+floorH)].join(' ');
      /* Bottom-aligned with the furniture shown: any slack the fit leaves over sits ABOVE the
         artwork, where it reads as more wall, instead of being split top and bottom and
         floating the floor in mid air. Centred without it, where there is no floor to ground. */
      return '<svg viewBox="'+vb+'" preserveAspectRatio="'+(ref?'xMidYMax':'xMidYMid')+' meet" role="img" aria-label="'+
        esc(l.n+(s.t?' '+s.t:'')+', '+pair(aW,aH)+' overall, '+P.length+' panel'+(P.length>1?'s':'')+
        (ref?', drawn to scale beside a standard '+fu.w+' inch '+fu.name:''))+'">'+
        (defs?'<defs>'+defs+'</defs>':'')+o+'</svg>';
    }

    /* ---- the panel inventory, grouped by size, largest first ---- */
    function legend(l,s){
      var P=G.panels(l,s), m={}, order=[];
      P.forEach(function(p){var k2=p.w+'x'+p.h; if(!m[k2]){m[k2]={w:p.w,h:p.h,tier:p.tier,n:0};order.push(k2);} m[k2].n++;});
      return order.map(function(k2){return m[k2];})
        .sort(function(a,b){return b.h-a.h||b.w-a.w;})
        .map(function(g){
          var sc=16/Math.max(g.w,g.h);
          return '<li><span class="tsf__sw"><i style="width:'+f(Math.max(4,g.w*sc))+'px;height:'+f(Math.max(4,g.h*sc))+
            'px;background:'+TIER[g.tier][0]+';border:1px solid '+TIER[g.tier][1]+'"></i></span>'+
            pair(g.w,g.h)+'<span class="tsf__n">×'+g.n+'</span></li>';
        }).join('');
    }

    function render(){
      var e=state.entry, s=e.sizes[state.sizeIdx];
      if(!s) return;
      var P=G.panels(e.l,s), aW=G.DW(s), aH=G.DH(s), g='';
      if(P.length>1){
        var gp = e.l.arr==='stack' ? (aH-s.cnt*s.ph)/(s.cnt-1)
               : e.l.arr==='grid'  ? (aW-2*s.pw)
               : (aW-P.length*s.pw)/(P.length-1);
        g='<span>Gap <b>'+one(Math.round(gp*10)/10)+'</b></span>';
      }
      var fu=FURNITURE.filter(function(x){return x.id===state.furn;})[0];
      var fin=bands(e.l.mat);
      var note = state.showRef
        ? 'Drawn to scale beside a standard '+one(fu.w)+' '+fu.name+', hung '+one(GAP_ABOVE)+
          ' above it.'+(data.flat?'':' Panels show the shape and the split, not the picture.')
        : 'Drawn at its own proportions, with no furniture for reference. Turn the toggle back on to compare it against a room.'+
          (data.flat?'':' Panels show the shape and the split, not the picture.');
      /* Say what the frame is: it is drawn to identify the finish, inside the published size,
         at proportions this workspace chose. Never let a drawing imply a specification. */
      if(fin) note += fin.kind==='print'
        ? ' The frame and mat are drawn inside the overall size to show the finish; their width is indicative.'
        : ' The frame and its floating gap are drawn inside the overall size to show the finish; their width is indicative.';

      slot.innerHTML=
        '<div class="tsf__card">'+
          '<div class="tsf__head"><h3 class="tsf__name">'+esc(e.l.n)+'</h3><span class="tsf__mat">'+esc(e.l.mat)+'</span></div>'+
          '<div class="tsf__seg'+(e.sizes.length>4?' tsf__seg--many':'')+'" role="group" aria-label="Choose a size">'+
            e.sizes.map(function(x,i){
              var yours=x.yours?'<b class="tsf__is">Yours</b>':'';
              return '<button type="button" data-s="'+i+'" aria-pressed="'+(i===state.sizeIdx)+'">'+
                (x.t ? esc(x.t)+'<span class="tsf__yours">'+pair(x.w,x.h)+yours+'</span>'
                     : pair(x.w,x.h)+(yours?'<span class="tsf__yours">'+yours+'</span>':''))+
                '</button>';
            }).join('')+
          '</div>'+
          '<div class="tsf__furn" role="group" aria-label="Compare against a piece of furniture">'+
            FURNITURE.map(function(x){
              return '<button type="button" data-f="'+x.id+'" aria-pressed="'+(state.showRef&&x.id===state.furn)+'">'+esc(x.label)+'</button>';
            }).join('')+
          '</div>'+
          '<div class="tsf__stage">'+scene(e.l,s)+'</div>'+
          '<p class="tsf__note">'+note+'</p>'+
          '<div class="tsf__overall"><span class="tsf__lab">On the wall</span><b>'+pair(aW,aH)+'</b></div>'+
          /* True for a stepped set (4 Pop, taller than listed) and for a rounded one (4 Horizontal,
             3 Piece 56x18, half an inch narrower than listed) alike. */
          ((s.iw||s.ih)?'<p class="tsf__fine">Listed as '+pair(s.w,s.h)+'. Hung as the guide shows, the set measures '+pair(aW,aH)+
            ' on the wall.</p>':'')+
          '<ul class="tsf__legend">'+legend(e.l,s)+'</ul>'+
          /* ⚠ Depth is the stretched canvas's own depth and is a real product fact. A framed
             print is paper behind glass and this workspace does not know its frame depth, so
             it gets NO depth figure rather than the canvas table's. */
          '<div class="tsf__meta"><span>Panels <b>'+P.length+'</b></span>'+
            (fin && fin.kind==='print' ? '' : '<span>Depth <b>'+one(G.DEPTH_IN)+'</b></span>')+
            g+'</div>'+
          '<div class="tsf__foot"><label class="tsf__toggle"><input type="checkbox" data-ref'+(state.showRef?' checked':'')+
            '>Show furniture for scale</label>'+
            /* Only where there ARE panels to have a gap between. On a single piece the line
               was inherited from the size chart and says nothing true. */
            (P.length>1?'<p class="tsf__fine">Overall size includes the gap between panels.</p>':'')+
          '</div>'+
        '</div>';

      slot.querySelectorAll('.tsf__seg button').forEach(function(b){
        b.addEventListener('click',function(){ state.preview=state.sizeIdx=+b.dataset.s; render(); });
      });
      /* Picking a piece of furniture turns the reference back on. Without that the tabs are
         dead controls whenever the toggle is off, which is worse than either state. */
      slot.querySelectorAll('.tsf__furn button').forEach(function(b){
        b.addEventListener('click',function(){ state.furn=b.dataset.f; state.showRef=true; render(); });
      });
      var t=slot.querySelector('[data-ref]');
      if(t) t.addEventListener('change',function(){ state.showRef=t.checked; render(); });
    }

    function sync(){
      var sel=G.readSelection(built.axes);
      var m=G.matchEntry(built.live,sel,state.preview);
      state.entry=m.entry;
      /* The buy box has a size: it wins and supersedes any chip preview, so a later clearing of
         the size (a layout change with the size group open) falls back to the largest, as the
         gallery does. No size but a chip was tapped here: that preview, clamped to this ladder by
         the engine. Neither: the largest size (owner 2026-09-17). */
      if(m.exact) state.preview=null;
      state.sizeIdx=(m.exact||state.preview!=null)?m.sizeIdx:m.entry.sizes.length-1;
      state.entry.sizes.forEach(function(x){ x.yours=!!(sel.sz && G.key(x.w+'x'+x.h)===G.key(sel.sz)); });
      render();
    }

    /* Bubble phase, deliberately not capture — see the header comment. */
    var bf=document.querySelector('.tia-buy__form');
    if(bf) bf.addEventListener('change',sync);
    var pf=document.querySelector('.product_section .product_form');
    if(pf){
      pf.addEventListener('change',sync);
      pf.addEventListener('click',function(ev){ if(ev.target.closest('.swatch-element')) setTimeout(sync,0); });
    }
    document.addEventListener('tia:unit',function(ev){
      state.unit=(ev.detail&&ev.detail.unit)==='cm'?'cm':'in';
      render();
    });

    sync();
  }

  function initAll(){ document.querySelectorAll('[data-tsf]').forEach(boot); }
  window.tiaSizeFitInit=initAll;
  /* Wait for the parser: this script sits inline before the sibling [data-tsc-fallback]
     block, so booting immediately would look for a fallback that does not exist yet. */
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initAll);
  else initAll();
})();
